// extracted by mini-css-extract-plugin
export default {"headerSection":"style_headerSection__c59sM","title":"style_title__8revs","link":"style_link__h4JAr","arrow":"style_arrow__elfBb","link_con":"style_link_con__2JsRv"};